import React, { useState, ReactNode } from 'react'
import { Popover } from 'react-tiny-popover'
import { mdiPlus, mdiChevronDown } from '@mdi/js'
import theme from 'theme_'
import { Icon } from '@mdi/react'

import { MenuItems, Button, ButtonTitle, Chevron } from './styles'

export { default as AddButtonItem } from './AddButtonItem'

interface AddButtonProps {
  title: ReactNode
  children: ReactNode
}

export const AddButton = ({ title, children }: AddButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      isOpen={isOpen}
      positions={['bottom']}
      content={<MenuItems>{children}</MenuItems>}
      padding={8}
      align="end"
      onClickOutside={() => setIsOpen(false)}
    >
      <Button variant="secondary" onClick={() => setIsOpen(!isOpen)}>
        <Icon path={mdiPlus} color={theme.colors.horizonOrange} size={1} />
        <ButtonTitle>{title}</ButtonTitle>
        <Chevron>
          <Icon
            path={mdiChevronDown}
            color={theme.colors.horizonOrange}
            size={1}
          />
        </Chevron>
      </Button>
    </Popover>
  )
}
